import type { MessengerMessage } from '@/api/client';

/** Имя для подписи «Переслано от …» (API: sender_name или virtual label). */
export function messengerForwardedSenderName(msg: Pick<MessengerMessage, 'forwarded_from_sender_name' | 'forwarded_from_label'>): string | null {
  const name = msg.forwarded_from_sender_name?.trim();
  if (name) return name;
  const label = msg.forwarded_from_label?.trim();
  return label || null;
}
